/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import ProgressChart from '@components/chart/ProgressChart';

import Colors from '@global/colors';

function IncentiveTracker(props) {
  return (
    <>
      <SociollaText style={styles.subTitle}>
        Sales Achivement Target / Sell In
      </SociollaText>
      <ProgressChart
        count={80}
        barHeight={10}
        grades={[100, 105, 110]}
        gradeCount={3}
        activeColor={Colors.orange0}
      />
      <SociollaText style={styles.subTitle}>Product Focus</SociollaText>
      <ProgressChart
        count={70}
        barHeight={10}
        lastGrade
        lastGradeText="FP 1"
        activeColor={Colors.blue4}
      />
      <ProgressChart
        count={90}
        barHeight={10}
        lastGrade
        lastGradeText="FP 2"
        activeColor={Colors.blue4}
      />
      <ProgressChart
        count={50}
        barHeight={10}
        lastGrade
        lastGradeText="FP 3"
        activeColor={Colors.blue4}
      />
      <SociollaText style={styles.subTitle}>DOORS</SociollaText>
      <ProgressChart
        title="Rp 100.000"
        titleBold
        count={70}
        barHeight={10}
        grades={[100, 105, 110]}
        gradeCount={3}
      />
      <SociollaText style={styles.subTitle}>
        Account Receivable (AR) Billing / REMISA
      </SociollaText>
      <ProgressChart
        title="Rp 250.000"
        titleBold
        count={102}
        barHeight={10}
        grades={[100, 105, 110]}
        gradeCount={3}
        activeColor={Colors.green1}
      />
    </>
  );
}

const styles = StyleSheet.create({
  subTitle: { fontSize: 12, color: Colors.grey1, marginBottom: 10 },
});

export default React.memo(IncentiveTracker, (prev, next) => prev == next);
